module.exports = __webpack_public_path__ + "static/logo-f5c3c1f5c7b94915a713bb4116866192.png";